import { useEffect, useRef } from "react";

export const Cursor = () => {
  const dotRef = useRef(null);
  const ringRef = useRef(null);

  useEffect(() => {
    if (window.matchMedia("(pointer: coarse)").matches) return;
    const dot = dotRef.current;
    const ring = ringRef.current;
    let mx = -100, my = -100, rx = -100, ry = -100;
    let raf;
    let hovering = false;

    const onMove = (e) => {
      mx = e.clientX;
      my = e.clientY;
    };
    const onOver = (e) => {
      const target = e.target.closest("a, button, [role='button'], input, textarea, [data-cursor]");
      hovering = !!target;
      ring.style.width = hovering ? "56px" : "36px";
      ring.style.height = hovering ? "56px" : "36px";
      ring.style.borderColor = hovering ? "#00F2FE" : "rgba(253,251,247,0.5)";
      dot.style.background = hovering ? "#FF5E36" : "#00F2FE";
    };
    const loop = () => {
      rx += (mx - rx) * 0.16;
      ry += (my - ry) * 0.16;
      dot.style.transform = `translate(${mx - 3}px, ${my - 3}px)`;
      ring.style.transform = `translate(${rx}px, ${ry}px) translate(-50%, -50%)`;
      raf = requestAnimationFrame(loop);
    };
    window.addEventListener("mousemove", onMove);
    window.addEventListener("mouseover", onOver);
    raf = requestAnimationFrame(loop);
    return () => {
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseover", onOver);
      cancelAnimationFrame(raf);
    };
  }, []);

  if (typeof window !== "undefined" && window.matchMedia("(pointer: coarse)").matches) {
    return null;
  }

  return (
    <>
      <div
        ref={dotRef}
        className="pointer-events-none fixed left-0 top-0 z-[99] h-1.5 w-1.5 rounded-full bg-[#00F2FE]"
        style={{ transition: "background 0.2s" }}
      />
      <div
        ref={ringRef}
        className="pointer-events-none fixed left-0 top-0 z-[99] h-9 w-9 rounded-full border"
        style={{
          borderColor: "rgba(253,251,247,0.5)",
          transition: "width 0.25s, height 0.25s, border-color 0.25s",
        }}
      />
    </>
  );
};
